<form #ngForm="ngForm" (ngSubmit)="onSubmit.emit($event)">
    <ng-content></ng-content>
</form>
